import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { User, Avatar, Name, Mail } from './AddUserComponents';

class ParticipantCard extends Component {
  render() {
    const { user, handleOnUserClick, className, primaryColor, isMenuB } = this.props;

    return (
      <User
        primaryColor={primaryColor}
        key={user._id}
        isEnabled={user.enabled}
        onClick={() => handleOnUserClick && handleOnUserClick(user)}
      >
        <Avatar className={className} src={user.picture} isMenuB={isMenuB} />
        <Name className={className}>{isMenuB ? `${user.name} ${user.surname}` : `${user.surname}, ${user.name}`}</Name>
        {!isMenuB && <Mail className={className}>{user.email ? `(${user.email})` : ''}</Mail>}
      </User>
    );
  }
}

ParticipantCard.propTypes = {
  user: PropTypes.object,
  handleOnUserClick: PropTypes.func,
  className: PropTypes.string,
  primaryColor: PropTypes.string,
  isMenuB: PropTypes.bool
};

export default ParticipantCard;
